import { Grid } from "@mui/material";
import React from "react";
import FeatureCard from "../../Components/Containers/FeatureCard";
import withAuth from "../../Hoc/withAuth";
import { DASHBOARD_SECTIONS } from "../../Components/Navigation/Drawer/moduleOptions";

const CDADashBoard = ({ user, modules, companyDetails }) => {
  if (
    !companyDetails?.company === "CDA Solutions" &&
    !user.userType === "admin"
  ) {
    return null;
  }

  const isAdmin = user.userType === "admin";

  return (
    <div>
      {Object.entries(DASHBOARD_SECTIONS).map(([key, section]) => {
        if (!section.checkAccess(modules, isAdmin)) return null;

        return (
          <React.Fragment key={key}>
            <h2>{section.title}</h2>
            <Grid container spacing={1} mb={3}>
              {section.features.map((feature, index) => {
                if (
                  (!isAdmin &&
                    !modules?.some((m) => feature.module.includes(m))) ||
                  (isAdmin && feature.hideFromAdmin)
                )
                  return null;

                return (
                  <Grid key={index} item xs={6} sm={6} md={4} lg={3} xl={2}>
                    <FeatureCard
                      company="CDA Solutions"
                      Icon={feature.icon}
                      title={feature.title}
                      link={feature.link}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default withAuth(CDADashBoard);

// {/* {(modules && modules.includes("crm")) || user.userType === "admin" ? (
//         <Grid item xs={6} sm={6} md={4} lg={3} xl={3}>
//           <FeatureCard
//             company="CDA Solutions"
//             Icon={AppRegistrationIcon}
//             title="CRM"
//             link="/crm"
//           />
//         </Grid>
//       ) : (
//         <></>
//       )} */}

// {/* {(modules && modules.includes("call-center-admin")) ||
// user.userType === "admin" ? (
//   <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
//     <FeatureCard
//       company="CDA Solutions"
//       Icon={PointOfSaleIcon}
//       title="Sale Orders"
//       link="/CDA/SalesOrders"
//     />
//   </Grid>
// ) : (
//   <></>
// )} */}

// {/* {(modules && modules.includes("questionnaire")) ||
// user.userType === "admin" ? (
//   <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
//     <FeatureCard
//       company="CDA Solutions"
//       Icon={SchoolIcon}
//       title="Questionnaire"
//       link="/CDA/UserQuestionnaires"
//     />
//   </Grid>
// ) : (
//   <></>
// )} */}

// {/* {(modules && modules.includes("questionnaire_admin")) ||
// user.userType === "admin" ? (
//   <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
//     <FeatureCard
//       company="CDA Solutions"
//       Icon={SchoolTwoToneIcon}
//       title="Questionnaire Admin"
//       link="/CDA/questionnaireAdmin"
//     />
//   </Grid>
// ) : (
//   <></>
// )} */}

// {/* {(modules && modules.includes("avm")) || user.userType === "admin" ? (
//           <Grid item xs={6} sm={6} md={4} lg={3} xl={3}>
//             <FeatureCard
//               company="CDA Solutions"
//               Icon={RecordVoiceOverTwoToneIcon}
//               title="AVM Management"
//               link="/CDA/avm_management"
//             />
//           </Grid>
//         ) : (
//           <></>
//         )} */}
//         {/* {(modules && modules.includes("santam")) ||
//         user.userType === "admin" ? (
//           <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
//             <FeatureCard
//               company="CDA Solutions"
//               Icon={BeachAccessIcon}
//               title="Santam"
//               link="/santam"
//             />
//           </Grid>
//         ) : (
//           <></>
//         )} */}

//  {/* {((modules && modules.includes("oe-manager")) ||
//       user.userType === "admin") && (
//       <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
//         <FeatureCard
//           company="CDA Solutions"
//           Icon={PeopleAltIcon}
//           title="Onboard Employees - Managers"
//           link="onboarding/manager/requisition"
//         />
//       </Grid>
//     )} */}

//     {/* {((modules && modules.includes("oe-hr")) ||
//       user.userType === "admin") && (
//       <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
//         <FeatureCard
//           company="CDA Solutions"
//           Icon={PeopleAltIcon}
//           title="Onboard Employees - HR"
//           link="/onboarding/hr/employees"
//         />
//       </Grid>
//     )} */}

//     {/* {((modules && modules.includes("oe-ceo")) ||
//       user.userType === "admin") && (
//       <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
//         <FeatureCard
//           company="CDA Solutions"
//           Icon={PeopleAltIcon}
//           title="Onboard Employees - CEO"
//           link="/onboarding/ceo/employees"
//         />
//       </Grid>
//     )} */}
